import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import Button from 'src/components//button/Button'
import Header from 'src/components//header/Header'
import styles from './addresses.module.scss'
import { usePagination, useSortBy, useTable } from 'react-table'
import { baseApiURL } from 'src/utils/utils'
import axios from 'axios'
import { StateContext, DispatchContext } from '../../AppContext'
import { IState, ParamTypes } from 'src/Interface'
import Footer from 'src/components/footer/Footer'
import Table from 'src/components/table/Table'
import { toast } from 'react-toastify'
import SubHeader from 'src/components/subHeader/SubHeader'
import useCancellablePromise from 'src/utils/useCancellablePromise'

const AddressesPOI: React.FunctionComponent = () => {
  const dispatch: React.Dispatch<any> = useContext(DispatchContext)
  const state: IState = useContext(StateContext)
  const [loading, setLoading] = useState(true)
  const location: any = useLocation()
  const { cancellablePromise } = useCancellablePromise()
  const { branchId, companyId } = useParams<ParamTypes>()

  useEffect(() => {
    if (state.user.accessToken) {
      cancellablePromise(axios(`${baseApiURL()}/branches/${branchId}/custom_addresses`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      }).then((result: any) => {
        setLoading(false)
        dispatch({ type: 'SET_CUSTOM_ADDRESSES', addresses: result.data })
      }).catch((err) => {
        toast(err.response.message)
        setLoading(false)
      }))
    }
  }, [branchId, state.user.accessToken, dispatch, cancellablePromise])

  const data = useMemo(() => state.customAddresses?state.customAddresses:[], [state.customAddresses])
  const columns = useMemo(() => [
    {
      Header: 'Vejnavn',
      accessor: 'streetName',
    },
    {
      Header: 'Husnummer',
      accessor: 'houseLetter',
      Cell: ({ cell }: any) => {
        return <span>{cell.row.original.houseNo}{cell.row.original.houseLetter}</span>
      }
    },
    {
      Header: 'By',
      accessor: 'city'
    },
    {
      Header: 'Postnummer',
      accessor: 'zipCode'
    },
    {
      Header: 'POI',
      accessor: 'poi'
    },
    {
      Header: 'Label',
      accessor: 'label'
    }
  ], [])


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    pageOptions,
    nextPage,
    gotoPage,
    canNextPage,
    canPreviousPage,
    state: pageState,
    previousPage,
    prepareRow,
  } = useTable({
    columns,
    data,
    autoResetPage: false
  }, useSortBy, usePagination)


  return (
    <>
      <Header />
      <SubHeader loading={loading} backPath={location.state.backPath ? location.state.backPath : '/companies'} title={
        <>
          <svg className='arrow-icon' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          <span className='color-gray tw-font-normal'>{location.state.from}</span> <span className='tw-mx-3 color-gray tw-font-normal'>/</span> <span className='text-black text-bold'>Brugerdefinerede adresser</span>
        </>
      }>
        <Button modifiers='tw-ml-auto' type='primary' label='Opret adresse' handleClick={() => dispatch({ showModal: true, type: 'SHOW_MODAL', modalType: 'addAddressPOI', branchId })} />
      </SubHeader>
      <main className={styles.container}>
        <Table
          getTableBodyProps={getTableBodyProps}
          getTableProps={getTableProps}
          prepareRow={prepareRow}
          loading={loading}
          page={page}
          handleClick={(addressId) => dispatch({ type: 'SHOW_ASIDE', show: true, asideType: 'AddressPOIDetails', addressId, branchId, size: 'small' })}
          headerGroups={headerGroups}
          type='addresses'
          companyId={companyId}
          branchId={branchId}
          state={{ background: location }}
        />
      </main>
      <Footer
        pageState={pageState}
        canNextPage={canNextPage}
        nextPage={nextPage}
        loading={loading}
        paginationLabel=''
        canPreviousPage={canPreviousPage}
        page={page}
        gotoPage={gotoPage}
        previousPage={previousPage}
        pageOptions={pageOptions}
        itemsLength={state.customAddresses?.length}
      />
    </>
  )
}

export default AddressesPOI
